<template>
  <div class="col-xl-12">
    <div class="notice notify-renewal" v-if="isPlanSwitchable">
      <h2>Open Enrollment Plan change Alert</h2>
      <p>

        Your plan is eligible to change for Jan 1, 2026, you can keep your existing plan or choose
        to change to another plan. Deadline to change is 12/15/2025. If you do
        not choose a new plan, your current plan will renew at the renewal rate.
      </p>
      <ul class="text-center mt-2" v-if="loadingPlan">
        <strong>Loading...</strong>
      </ul>
      <ul v-else>
        <dashboard-enrollment-current-plan :current-plan.sync="currentPlan" />
        <dashboard-enrollment-renew-plan
            :current-plan.sync="currentPlan"
            @renewalsStatus="checkRenewalStatus()"
            @onSwitchedPlan="getCurrentNewPlan()"
        />
      </ul>
    </div>
    <!--For Solistics-->

     <!-- <div class="notice notify-renewal" v-if="hasActiveSolisticePlan">
      <h2>Plan Renewal Alert</h2>
      <p>
        Your plan ({{currentPlan}}) renews June 1, 2025, you can keep your existing plan or choose
        to change to another plan. Deadline to change is 15/12/2024.
      </p>
    </div> -->
    <!--For Delta Dental & VSP Vision-->
    <!-- <div class="notice notify-renewal" v-if="hasActiveDeltaVSPPlan">
      <h2>Plan Renewal Alert</h2>
      <p>
        Your plan ({{currentPlan}}) renews June 1, 2025, you can keep your existing plan or choose
        to change to another plan. Deadline to change is 15/12/2024.
      </p>
    </div> -->

<!--For Solistics-->

    <div class="notice notify-renewal" v-if="hasActiveSolisticePlan">
      <h2>Plan Renewal Alert</h2>
      <p>

        Your plan ({{currentPlan}}) renewed on June 1, 2025, as of July 1, 2025 your current plan will be billed at the updated renewal rate.
      </p>
    </div>


  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Api from "@/resource/MemberApi";
import DashboardEnrollmentRenewPlan from "./DashboardEnrollment/DashboardEnrollmentRenewPlan.vue";
import DashboardEnrollmentCurrentPlan from "./DashboardEnrollment/DashboardEnrollmentCurrentPlan.vue";

export default {
  name: "DashboardEnrollmentPlan",
  components: {
    DashboardEnrollmentRenewPlan,
    DashboardEnrollmentCurrentPlan,
  },
  data: () => ({
    currentPlan: false,
    loadingPlan: false,
    isPlanSwitchable: false,
    hasActiveSolisticePlan: false,
    hasActiveDeltaVSPPlan: false,
    deltaVSPPlanIds: [945, 946, 947, 948, 954, 955, 956, 1027, 1547, 1546, 1548, 1561, 1970, 1971]
  }),
  computed: {
    ...mapGetters({ memberId: "memberId" }),
  },
  methods: {
    getAllPlans() {
      this.loadingPlan = true;
      Api.get("v2/get-policy-list")
          .then((response) => {
            this.policyDetails = response.data.data.policy_details;

            // Check if any active policy has an MM plan
            this.hasMajorMedicalPlan = false;
            
            // Reset flags
            this.hasActiveSolisticePlan = false;
            this.hasActiveDeltaVSPPlan = false;
            
            this.policyDetails.forEach(policy => {
              if (policy.status === "ACTIVE") {
                policy.plans.forEach(plan => {
                  if (plan.status === "ACTIVE") {
                    // Check for Solistic plans
                    if (plan.plan_name.includes("EWA Solstice Dental") ||
                        plan.plan_name.includes("PW Solstice Dental")) {
                      this.hasActiveSolisticePlan = true;
                      this.currentPlan = plan.plan_name;
                    }
                    
                    // Check for Delta Dental & VSP Vision plans by plan_id
                    if (this.deltaVSPPlanIds.includes(parseInt(plan.plan_id))) {
                      this.hasActiveDeltaVSPPlan = true;
                      this.currentPlan = plan.plan_name;
                    }
                  }
                });
              }
            });

            this.loadingPlan = false;
            this.$emit("onSwitchedPlanGetProducts");
          })
          .catch(() => {
            this.policyDetails = [];
            this.loadingPlan = false;
          })
          .finally(() => {
            this.loadingPlan = false;
          });
    },
    getCurrentNewPlan(){
      this.getCurrentPlan()
      this.$emit("onSwitchedPlanGetProducts")
    },
    getCurrentPlan() {
      this.loadingPlan = true
      const url = `v2/get-current-major-medical-plan/${this.memberId}`;
      Api.get(url)
          .then((res) => {
            this.currentPlan = res.data.data;
            this.loadingPlan = false
          })
          .catch(() => {
            this.currentPlan = null;
            this.loadingPlan = false
          }).finally(() => {
        this.loadingPlan = false
      });
    },
    checkRenewalStatus() {
      this.isLoading = true;
      let url = `v2/check-if-plan-switchable/${this.memberId}`;
      Api.get(url)
          .then((res) => {
            this.isLoading = false;
            this.isPlanSwitchable = res.data.data.is_plan_switchable
          })
          .catch(() => {
            this.plans = [];
            this.isLoading = false;
          });
    },
  },
  created() {
    this.getAllPlans()
    // this.getCurrentPlan();
    // this.checkRenewalStatus();
  },
};
</script>

